import { Type, TokenPair } from '@hugendubel/ws_client';
import { WsBonusShopCustomerData } from './WsBonusShopCustomerData';

export class WsInitResult {
    points: number;
    mediaBaseUrl: string;
    isPhysicalBookstore: boolean;
    customerData: WsBonusShopCustomerData;
    backLink?: string;
    tokenPair?: TokenPair;

    constructor(
        points: number,
        mediaBaseUrl: string,
        isPhysicalBookstore: boolean,
        customerData: WsBonusShopCustomerData,
        backLink?: string,
        tokenPair?: TokenPair
    ) {
        this.points = points;
        this.mediaBaseUrl = mediaBaseUrl;
        this.isPhysicalBookstore = isPhysicalBookstore;
        this.customerData = customerData;
        this.backLink = backLink;
        this.tokenPair = tokenPair;
    }
    static fromApi(json: any): WsInitResult {
        const tokenPair = json.tokenPair;
        if (tokenPair) {
            // if token pair was provided, we make the necessary checks
            Type.notEmptyString(tokenPair.accessToken, 'InitResult.accessToken');
            Type.notEmptyString(tokenPair.refreshToken, 'InitResult.refreshToken');
        }

        return new WsInitResult(
            Type.number(json.points, 'InitResult.points'),
            Type.string(json.mediaBaseUrl, 'InitResult.mediaBaseUrl'),
            Type.optional.boolean(json.physicalBookstore, 'InitResult.physicalBookstore') || false,
            WsBonusShopCustomerData.fromApi(Type.object(json.customerData, 'InitResult.customerData')),
            Type.optional.string(json.backlink, 'InitResult.backlink'),
            tokenPair
        );
    }
}
